import {FavoritesProvider} from '@context/Favorites'
import {PageDataProvider} from '@context/PageData'
import {MenuComponent} from 'assets/ts/components'
import {useEffect} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {Content} from './components/Content'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {ScrollTop} from './components/ScrollTop'
import {Sidebar} from './components/sidebar/Sidebar'

const MasterLayout = () => {
  const location = useLocation()
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <PageDataProvider>
      <FavoritesProvider>
        <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
          {/* begin::Page */}
          <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
            <HeaderWrapper />
            {/* begin::Wrapper */}
            <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
              <Sidebar />
              {/* begin::Main */}
              <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                <div className='d-flex flex-column flex-column-fluid'>
                  <Content>
                    <Outlet />
                  </Content>
                </div>
              </div>
              {/* end::Main */}
            </div>
            {/* end::Wrapper */}
          </div>
          {/* end::Page */}
        </div>
        <ScrollTop />
      </FavoritesProvider>
    </PageDataProvider>
  )
}

export {MasterLayout}
